module.exports = {
      id: "glyph:copy-paste-usage",
      viewBox: "0 0 24 24",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#glyph:copy-paste-usage",
      toString: function () {
        return this.url;
      }
    }